<template>
    <div class="chart-serial" v-bind:class="classes">
        <div v-bind:id="id" class="graph"></div>
    </div>
</template>

<script>
    var e = this;
    module.exports = {
        created: function () {
            this.currentChartData = this.chartData;
        },
        data:function() {
            return {
                chart:false,
                legendEnabled:false,
                windowGraphSizes:{
                    535:19,
                    768:25,
                    1250:40,
                    'default':43
                },
                graphSize:43,
                currentChartData:false
            }
        },
        watch: {
            bindedItem:function(newVal,_) {
                newVal = Number(newVal.replace(/[^0-9\.]+/g,""));
                var newDataProvider = JSON.parse(JSON.stringify(this.chart.dataProvider));
                if(this.bindedKey != undefined) {
                    $.each(newDataProvider[newDataProvider.length - 1], function (key, item) {
                        if(key == this.bindedKey) {
                            newDataProvider[newDataProvider.length - 1][key] = newVal;
                        }
                    }.bind(this));
                }
                this.currentChartData = newDataProvider;
                this.getMaxValue(newDataProvider);
                this.chart.animateData( newDataProvider, { duration:1000 } );
            },
            bindedData:function(newVal,_) {
                this.currentChartData = newVal;
                this.getMaxValue(newVal);
                this.chart.animateData( newVal, { duration:1000 } );
            }
        },
        props:{
            id:{ type:String, default:"chart" },
            chartTitle: { type:String, default:""},
            categoryField:{ type:String, default:"category" },
            colors:{ type:Array, default:function() { return ['#005550','#078466','#59a996','#adcc77']}},
            classes:{ type:String,default:''},
            valueAxes: {
                type:Array,
                default: function() { return[
                    {
                        title:"",
                        labelsEnabled:true,
                        gridAlpha:0,
                        gridColor:'#ccc',
                        zeroGridAlpha:0,
                        color:'#9c9c9c',
                        minVerticalGap:40,
                        stackType:'regular',
                        axisAlpha:0,
                        fontSize:12,
                        unit:'$',
                        unitPosition:'left',
                        labelsEnabled: false
                    }
                ]}
            },
            categoryAxis: {
                type:Object,
                default: function() { return {
                    gridAlpha: 0,
                    gridPosition:"start",
                    position:'left',
                    color:'#9c9c9c',
                    axisAlpha:0,
                    fontSize:12,
                    listeners: [
                        {
                            event: 'clickItem',
                            method: function(event) {
                                var data = event.serialDataItem.dataContext.data;
                                if(data != undefined) {
                                    if (e.triggerDrawer != undefined) {
                                        e.$root.$openDrawer(e.triggerDrawer+'?chart-data=' + data);
                                    }
                                }
                            }
                        }
                    ]
                }}
            },
            chartData:{
                type:Array
            },
            chartGraphs:{
                type:Array,
                default: function() { return  [
                    {
                        "valueField": "value"
                    }
                ] }
            },
            bindedData:{
                type:Array
            },
            bindedItem: {
                type:String
            },
            bindedKey: {
                type:String
            },
            triggerDrawer:{type:String}
        },
        methods: {
            getMaxValue:function() {
                var max = 0;
                var valueFields = [];
                $.each(this.chartGraphs,function(index,value) {
                    valueFields.push(value.valueField);
                });
                $.each(this.currentChartData,function(index,arr) {
                    var columnTotal = 0;
                    $.each(arr,function(type,value) {
                        if(valueFields.includes(type)) {
                            columnTotal += parseFloat(value);
                        }
                    });
                    if(columnTotal > max) {
                        max = columnTotal;
                    }
                });
                if(max > 0) {
                    this.valueAxes[0].maximum = max;
                    this.chart.strictMinMax = true;
                }
            }
        },
        mounted:function() {
            e = this;
            this.chart = AmCharts.makeChart(this.id,{
                type: "serial",
                marginTop:0,
                marginRight:0,
                marginLeft:0,
                autoMarginOffset:0,
                categoryField: this.categoryField,
                categoryAxis: this.categoryAxis,
                graphs: this.chartGraphs,
                valueAxes: this.valueAxes,
                color:'rgba(0,0,0,0)',
                colors:this.colors,
                startDuration:0.4,
                startEffect:'easeOutSine',
                legend: {
                    "useGraphSettings": true,
                    "enabled":this.legendEnabled
                },
                titles: [
                    {
                        "size": 15,
                        "text": this.chartTitle
                    }
                ],
                dataProvider: this.chartData,
                listeners: [
                    {
                        event: 'clickGraphItem',
                        method: function(event) {
                            var data = event.item.dataContext.data;
                            if(data != undefined) {
                                if (e.triggerDrawer != undefined) {
                                    e.$root.$openDrawer(e.triggerDrawer+'?chart-data=' + data);
                                }
                            }
                        }
                    }
                ]
            });
            this.getMaxValue();
        }
    }
</script>
